import Grid from '@mui/material/Grid2';

import Column from '../../components/Column';
import theme from '../../theme';
import { useAttributionPageContext } from '../../hooks/useAttributionPage';

import AdvertiserAverageCPMBasicBarChartCard from './AdvertiserAverageCPMBasicBarChartCard';
import AdvertiserInvestmentPieChartCard from './AdvertiserInvestmentPieChartCard';
import AdvertiserPerformanceGroupedBarChartCard from './AdvertiserPerformanceGroupedBarChartCard';

export default function AdvertiserMatchbackCampaignChartView() {
    const { isFetchingPerformances } = useAttributionPageContext();

    return (
        <Column gap={3}>
            <Grid container spacing={2}>
                <Grid size={6}>
                    <AdvertiserInvestmentPieChartCard loading={isFetchingPerformances} />
                </Grid>

                <Grid size={6}>
                    <AdvertiserAverageCPMBasicBarChartCard loading={isFetchingPerformances} />
                </Grid>
            </Grid>
            <Grid sx={{ mt: theme.spacing(1) }} size={12}>
                <AdvertiserPerformanceGroupedBarChartCard loading={isFetchingPerformances} />
            </Grid>
        </Column>
    );
}
